import { render, staticRenderFns } from "./topItems.vue?vue&type=template&id=0534f5d9&"
import script from "./topItems.vue?vue&type=script&lang=js&"
export * from "./topItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports